import get from 'lodash/get';

/**
 * @param  {Object} state
 * @return {Object}
 */
export const getEntities = (state) => get(state, 'entities') || {};

/**
 * @param  {Object} state
 * @param  {String} entityName
 * @return {Object}
 */
export const getEntitySelector = (state, entityName) => get(getEntities(state), `${entityName}`) || {};
